exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* stylelint-enable */\n", ""]);

// exports
exports.locals = {
	"animation-duration-ms": "200"
};